<template>
  <div id="sakura">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Sakura",
  mounted() {
    // const doc = document.documentElement;
    // doc.style.fontSize = doc.clientWidth / 10 + "px";
  },
};
</script>

<style lang="less" scoped>
#sakura {
  position: relative;
  width: 100%;
  // min-width: 320px;
  // max-width: 750px;
  margin: 0 auto;
  height: 100vh;
  height: 100svh;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/sakura/App.vue